import store from 'store';
import get from 'lodash/get';

export function getSelectedOutletIdFromLocalStorage(): string[] | undefined {
  const user = store.get('response:login');
  const userId = get(user, 'id', 0);
  return store.get(`moka:selectedOutletId:${userId}`);
}

export function setSelectedOutletIdToLocalStorage(outletId) {
  const user = store.get('response:login');
  const userId = get(user, 'id', 0);
  return store.set(`moka:selectedOutletId:${userId}`, outletId);
}

export function assignOutletIdHeader(headers) {
  const selectedOutletId = getSelectedOutletIdFromLocalStorage();

  if (selectedOutletId === undefined || selectedOutletId.length > 1) {
    return headers;
  }

  const outletIdHeader = {
    headers: { OUTLET_ID: selectedOutletId },
  };
  return { ...headers, ...outletIdHeader };
}
